import type { CanDeactivateFn } from '@angular/router';

export interface TpTemplateUnsavedAware {
    hasUnsavedChanges(): boolean;
}

/** Route-leave guard for the template editor: confirm before dropping unsaved section edits. */
export const tpTemplateUnsavedGuard: CanDeactivateFn<TpTemplateUnsavedAware> = (component) => {
    if (!component?.hasUnsavedChanges?.()) return true;
    return window.confirm('You have unsaved changes to this section. Leave and discard them?');
};
